import React, { ReactElement, useContext } from 'react'

import Heading from '../../Common/Components/Heading'
import Fieldset from '../../Common/Components/Fieldset'
import P from '../../Common/Components/P'
import FormRow from '../../Common/Components/FormRow'
import Checkbox from '../../Common/Components/Checkbox'

import { LanguageContext } from '../../Common/Contexts'

import CLanguageHandler from '../../../NonReact/Languages/LanguageHandler'
import { AlarmActions as AlarmActionsLanguage } from '../../../../i18n'
import { HeadingLevel } from '../../Common/Components/Heading/Heading'
// CSS imports. Commented out because of current build process.
// import './alarmActions.scss'

/**
 * Component properties type.
 */
type Props = {
    playSound: boolean
    setPlaySound: (checked: boolean) => void
    activeWindow: boolean
    setActiveWindow: (checked: boolean) => void
}

/**
 * Alarm actions section in Alarms tab of report configuration modal window.
 *
 * @param playSound Report property.
 * @param setPlaySound Setter for corresponding report property.
 * @param activeWindow Report property.
 * @param setActiveWindow Setter for corresponding report property.
 */
const AlarmActions: React.FC<Props> = ({
    playSound,
    setPlaySound,
    activeWindow,
    setActiveWindow
}: Props): ReactElement => {
    const language = useContext(LanguageContext) as CLanguageHandler
    language.loadBundle('AlarmActions')

    return (
        <Fieldset className='alarm-actions'>
            <Heading level={HeadingLevel.ONE}>{language.get(AlarmActionsLanguage.AlarmActions_SectionHeader)}</Heading>
            <P>{language.get(AlarmActionsLanguage.AlarmActions_SectionPara)}</P>
            <FormRow className={'play-sound'}>
                <Checkbox
                    onChange={setPlaySound}
                    isChecked={playSound}
                    labelLeft={language.get(AlarmActionsLanguage.PlaysoundLabel)}
                />
            </FormRow>
            <FormRow className={'active-window'}>
                <Checkbox
                    onChange={setActiveWindow}
                    isChecked={activeWindow}
                    labelLeft={language.get(AlarmActionsLanguage.ActivewindowLabel)}
                />
            </FormRow>
        </Fieldset>
    )
}

export default React.memo(AlarmActions)
